import React, { useState, useEffect } from 'react';

import Icon from '@mui/material/Icon';
import DeviceHubRoundedIcon from '@mui/icons-material/DeviceHubRounded';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';


// material
import { alpha, styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import {
  Card, Box, Grid, Typography, Accordion,
  Modal,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  TextField,
  InputAdornment,
  FormHelperText
} from '@mui/material';
import { LoadingButton } from '@mui/lab';




import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';

import { parseValidationErrorMessage } from '../../../utils/Utilities';
import {  APP_CONSTANTS } from '../../../URLConstants';
import {fdatetimeWithDash} from '../../../utils/formatTime'
import { useAuth } from '../../customContextProviders/AuthContext';
import {CreateOrganization} from '../../../network/Organization'
import AlertDialog from '../../AlertDialog'







// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.primary.darker,
  backgroundColor: "#FFFFFF"
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
    theme.palette.primary.dark,
    0.24
  )} 100%)`
}));


const useStyles = makeStyles({
  customDashCard: {
    background: "#FFFFFF",
    boxShadow: "10px 10px 19px 1px #EAEAFF",
    borderRadius: "20px",
    minHeight: "190px"
  },
});


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: '30%',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: 1
};

const OrganizationSchema = Yup.object().shape({
  organizationName: Yup.string()
    .required('Required'),
    organizationEmail: Yup.string()
    .required('Required'),
    organizationSlug: Yup.string()
    .required('Required'),
    phone: Yup.string()
    .required('Required'),
    address: Yup.string()
    .required('Required'),
 

});






export default function CreateOrganizationModal({ opneAssignedModal, handleClose, onAction , deviceData}) {

 

  const [openAlertDialog,setOpenAlertDialog]=useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",
   
});

  const addOrganizationFormik = useFormik({
    initialValues: {
        organizationName: '',
        organizationEmail:'',
        phone:'',
        organizationSlug:'',
        address:''
    },
    validationSchema: OrganizationSchema,
    onSubmit: () => {

      onAction(APP_CONSTANTS.API_INPROGRESS_ACTION,null)
      CreateOrganization(addOrganizationFormik?.values?.organizationName,addOrganizationFormik?.values?.organizationSlug,
        addOrganizationFormik?.values?.organizationEmail,"IN",addOrganizationFormik?.values?.phone,
        addOrganizationFormik?.values?.address,"active","https://www.proxgy.com/assets/logo.png").then((res)=>{
          addOrganizationFormik.setSubmitting(false)
          handleClose()
          onAction(APP_CONSTANTS.API_SUCCESS_ACTION,null)
          setAlertDialogMetas({ ...alertDialogMetas, message: `${addOrganizationFormik?.values?.organizationName} successfully created !`, title: "Organization Created.", btnLabel: "OK" });
          setOpenAlertDialog(true)
         
      }).catch((error)=>{
        addOrganizationFormik.setSubmitting(false)
        handleClose()
        onAction(APP_CONSTANTS.API_FAILURE_ACTION,null)
        setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(error) , title: "Error", btnLabel: "OK" });
        setOpenAlertDialog(true)
  
      })

    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = addOrganizationFormik;


 







  return (
    <Box>
      <Modal
        open={opneAssignedModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid='create-org-modal'
      >

        <FormikProvider value={addOrganizationFormik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Box sx={style}>
              <Typography sx={{ fontSize: 18, fontWeight: 900 }}>Create Organization</Typography>

              <Grid container spacing={2} sx={{mt:2}}>
              <Grid item xs={12} sm={12} md={6}>
              <FormControl  fullWidth>
                  <TextField
                    label="Organization Name"
                    id="organizationName"
                    name="organizationName"
                    variant="outlined"
                    {...getFieldProps('organizationName')}
                    error={Boolean(touched.organizationName && errors.organizationName)}
                    helperText={touched.organizationName && errors.organizationName}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={6}>
              <FormControl  fullWidth>
                  <TextField
                    label="Slug"
                    id="organizationSlug"
                    name="organizationSlug"
                    variant="outlined"
                    {...getFieldProps('organizationSlug')}
                    error={Boolean(touched.organizationName && errors.organizationSlug)}
                    helperText={touched.organizationSlug && errors.organizationSlug}
                  />
                </FormControl>

                </Grid>

              <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth >
                  <TextField
                    label="Email"
                    id="organizationEmail"
                    name="organizationEmail"
                    type="email"
                    variant="outlined"
                    {...getFieldProps('organizationEmail')}
                    error={Boolean(touched.organizationEmail && errors.organizationEmail)}
                    helperText={touched.organizationEmail && errors.organizationEmail}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={6}>

              <FormControl fullWidth >
                    <TextField
                      label="Mobile No"
                      id="phone"
                      name="phone"
                      variant="outlined"
                      {...getFieldProps('phone')}
                      error={Boolean(touched.phone && errors.phone)}
                      helperText={touched.phone && errors.phone}/>

                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>

                <FormControl fullWidth  >
                  <TextField
                    label="Organization Address"
                    id="address"
                    name="address"
                    variant="outlined"
                    {...getFieldProps('address')}
                    error={Boolean(touched.address && errors.address)}
                    helperText={touched.address && errors.address}
                  />
                </FormControl>

                  </Grid>

              </Grid>
              <Box sx={{display:'flex',justifyContent:'center'}}>
              <LoadingButton loading={addOrganizationFormik?.isSubmitting} sx={{mt:3}} variant="contained" type='submit'  size="large" >Create</LoadingButton>

              </Box>


            </Box>
          </Form>
        </FormikProvider>

      </Modal>

      <AlertDialog openAlertDialog={openAlertDialog} message={alertDialogMetas?.message} title={alertDialogMetas?.title} 
          btnLabel={alertDialogMetas?.btnLabel}  handleClose={()=>setOpenAlertDialog(false)} />
    </Box>
  );
}

